<template>
  <v-container fluid>
    <privilege-password v-if="hasPassword"></privilege-password>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="clusterPrivileges"
          no-data-text='No support access'
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <support-request-form :cluster="clusterName">
                <v-btn color="primary">Ask support access to "{{ clusterName }}"</v-btn>
              </support-request-form>
            </v-toolbar>
          </template>
          <template v-slot:item.user.deleteAfterDate="{ item }">
            <span>{{ new Date(item.user.deleteAfterDate).toLocaleString() }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <confirm-delete-privileges :username="item.user.username" class="float-left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" v-bind="attrs" v-on="on">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Delete {{ item.ipAddress }}</span>
              </v-tooltip>
            </confirm-delete-privileges>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import SupportRequestForm from './SupportRequestForm.vue';
import ConfirmDeletePrivileges from './ConfirmDeletePrivileges.vue';
import PrivilegePassword from './PrivilegePassword.vue';
const { mapState, mapActions } = createNamespacedHelpers('atlasadmin');
export default {
  name: 'SupportAccess',
  components: { SupportRequestForm, ConfirmDeletePrivileges, PrivilegePassword },
  async created() {
    await this.getSupportAccessPrivileges();
  },
  methods: {
    ...mapActions(['getSupportAccessPrivileges'])
  },
  computed: {
    ...mapState(['clusters', 'clusterPrivileges', 'password']),
    clusterName() {
      return this.clusters.length > 0 ? this.clusters[0].name : 'unknown';
    },
    hasPassword() {
      return this.password === null ? false : true;
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Username',
          value: 'user.username',
          sortable: true
        },
        {
          text: 'Cluster',
          value: 'cluster',
          sortable: true
        },
        {
          text: 'Role',
          value: 'role',
          sortable: true
        },
        {
          text: 'Expires On',
          value: 'user.deleteAfterDate',
          sortable: true
        },
        {
          text: 'Action',
          value: 'actions',
          sortable: false,
          align: 'end'
        }
      ]
    };
  }
};
</script>

<style></style>
